import React from 'react';
import classnames from 'classnames';
import { CheckCircle, XCircle } from "react-bootstrap-icons";
import Alert from 'react-bootstrap/Alert';
import '../../influencer/pages/home/CookiesPrompt.scss';

const FlashMessage = ({ message, deleteFlashMessage }) => {
  const { id, type, text, onClose } = message;

  const onCloseHandler = () => {
    if (onClose) {
      onClose();
    }
    deleteFlashMessage(message);
  };

  return (
    <Alert key={id} className='message-component' variant={classnames({
      'success': type === 'success',
      'danger': type === 'error'
    })} dismissible onClose={onCloseHandler}>
      {type === 'success' && <CheckCircle className={`message-prompt-info-icon success`}></CheckCircle>}
      {type === 'error' && <XCircle className={`message-prompt-info-icon error`}></XCircle>}
      <p className='message-prompt-text text-2 m-0'>{text}</p>
    </Alert>
  );
};

export default FlashMessage;
